import { missingField } from 'app/constants';
import { convertToFormat } from 'app/helpers/dateHelper';

export const formatDate = (date: string | null | Date) => {
  let defaultFormat = 'MM/DD/YYYY';
  const formattedDate = convertToFormat(date, defaultFormat);
  return formattedDate === null ? '' : formattedDate;
};
const formatTime = time => {
  time = time?.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
  let convertedTime = time;
  let splittedTime = time[0].split(' ')?.length > 1 ? time[0].split(' ') : time[0].split('T');
  if (splittedTime?.length > 1 && splittedTime[1].split(':').length > 1) {
    time = splittedTime[1].split(':');
    time[2] = +time[0] < 12 ? ' AM' : ' PM';
    time[0] = +time[0] % 12 || 12;
    convertedTime = time[0] + ':' + time[1] + time[2];
  }
  return convertedTime;
};

const formatAmount = (amount: string) => {
  return (
    '$' +
    Number(amount)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  );
};

export const flattenPlacementDetailReport = (data: any) => {
  return {
    payBonusSection: {
      payRates: data?.payRates
        ? data?.payRates?.map(payRate => {
            return {
              orderId: payRate?.orderId ?? missingField,
              skillSet: payRate?.skillset ?? missingField,
              facilityId: payRate?.facilityId ?? missingField,
              facilityPPId: payRate?.facilityPPId ?? missingField,
              payRateId: payRate?.payRateId ?? missingField,
              payRateLineId: payRate?.payRateLineId ?? missingField,
              shiftId: payRate?.shiftId ?? missingField,
              regularRate: payRate?.regularRate ? formatAmount(payRate?.regularRate) : missingField,
              overtimeFactor: payRate?.overtimeFactor ? parseFloat(payRate?.overtimeFactor).toFixed(2) : missingField,
              doubleTimeFactor: payRate?.doubletimeFactor
                ? parseFloat(payRate?.doubletimeFactor).toFixed(2)
                : missingField,
              holidayFactor: payRate?.holidayFactor ? formatAmount(payRate?.holidayFactor) : missingField,
              onCallRate: payRate?.onCallRate ? formatAmount(payRate?.onCallRate) : missingField,
              callBackFactor: payRate?.callBackFactor ? formatAmount(payRate?.callBackFactor) : missingField,
              chargePremium: payRate?.chargePremium ? formatAmount(payRate?.chargePremium) : missingField,
              timestamp: payRate?.timestamp ?? missingField,
              holidayRate: payRate?.holidayRate ? formatAmount(payRate?.holidayRate) : missingField,
              callbackRate: payRate?.callbackRate ? formatAmount(payRate?.callbackRate) : missingField,
              payroll: payRate?.payroll ?? missingField,
              paysGWW: payRate?.paysGWW ?? missingField,
              descShift: payRate?.descShift ?? missingField,
              compositeRate: payRate?.compositeRate ? formatAmount(payRate?.compositeRate) : missingField,
              takeHomeRate: payRate?.takeHomeRate ? formatAmount(payRate?.takeHomeRate) : missingField,
            };
          })
        : [
            {
              orderId: missingField,
              skillSet: missingField,
              facilityId: missingField,
              facilityPPId: missingField,
              payRateId: missingField,
              payRateLineId: missingField,
              shiftId: missingField,
              regularRate: missingField,
              overtimeFactor: missingField,
              doubleTimeFactor: missingField,
              holidayFactor: missingField,
              onCallRate: missingField,
              callBackFactor: missingField,
              chargePremium: missingField,
              timestamp: missingField,
              holidayRate: missingField,
              callbackRate: missingField,
              payroll: missingField,
              paysGWW: missingField,
              descShift: missingField,
              compositeRate: missingField,
              takeHomeRate: missingField,
            },
          ],
      bonusDetails:
        data?.bonusDetails && data?.bonusDetails?.length > 0
          ? data?.bonusDetails?.map(bonus => {
              return {
                orderId: bonus?.orderId ?? missingField,
                bonusId: bonus?.bonusId ?? missingField,
                bonusAmount: bonus?.bonusAmount ? formatAmount(bonus?.bonusAmount) : missingField,
                shifts: bonus?.shifts ?? missingField,
                billingAmount: bonus?.billingAmount ?? missingField,
                approvalDate: bonus?.approvalDate ?? missingField,
                startDate: bonus?.startdate ? formatDate(bonus?.startdate) : missingField,
                endDate: bonus?.endDate ? formatDate(bonus?.endDate) : missingField,
                minimumWeeksWorked: bonus?.minimumWeeksWorked ?? missingField,
                descSortAssignment: bonus?.descSortAssignment ?? missingField,
                descBonusType: bonus?.descBonusType ?? missingField,
                descPayer: bonus?.descPayer ?? missingField,
                descBillingType: bonus?.descBillingType ?? missingField,
                descPaymentType: bonus?.descPaymentType ?? missingField,
                descApprovalType: bonus?.descApprovalType ?? missingField,
                descShortHoursType: bonus?.descShortHoursType ?? missingField,
                notes: bonus?.notes ?? missingField,
              };
            })
          : [
              {
                orderId: missingField,
                bonusId: missingField,
                bonusAmount: missingField,
                shifts: missingField,
                billingAmount: missingField,
                approvalDate: missingField,
                startDate: missingField,
                endDate: missingField,
                minimumWeeksWorked: missingField,
                descSortAssignment: missingField,
                descBonusType: missingField,
                descPayer: missingField,
                descBillingType: missingField,
                descPaymentType: missingField,
                descApprovalType: missingField,
                descShortHoursType: missingField,
                notes: missingField,
              },
            ],

      shiftDifferentials:
        data?.facilityPPShiftDifferentials && data?.facilityPPShiftDifferentials?.length > 0
          ? data?.facilityPPShiftDifferentials?.map(shiftDifferential => {
              return {
                skillSet: shiftDifferential?.skillset ?? missingField,
                facilityId: shiftDifferential?.facilityId ?? missingField,
                facilityPPId: shiftDifferential?.facilityPPId ?? missingField,
                payRateId: shiftDifferential?.payRateId ?? missingField,
                startTime: shiftDifferential?.startTime ? formatTime(shiftDifferential?.startTime) : missingField,
                endTime: shiftDifferential?.endTime ? formatTime(shiftDifferential?.endTime) : missingField,
                amount: shiftDifferential?.amount ? formatAmount(shiftDifferential?.amount) : missingField,
                shiftDifferentialTypeId: shiftDifferential?.shiftDifferentialTypeId ?? missingField,
                descShiftDifferentialType: shiftDifferential?.descShiftDifferentialType ?? missingField,
                addedByName: shiftDifferential?.addedByName ?? missingField,
                descShiftDifferentialDescriptionType:
                  shiftDifferential?.descShiftDifferentialDescriptionType ?? missingField,
                templateTypeId: shiftDifferential?.templateTypeId ?? missingField,
              };
            })
          : [
              {
                skillSet: missingField,
                facilityId: missingField,
                facilityPPId: missingField,
                payRateId: missingField,
                startTime: missingField,
                endTime: missingField,
                amount: missingField,
                shiftDifferentialTypeId: missingField,
                descShiftDifferentialType: missingField,
                addedByName: missingField,
                descShiftDifferentialDescriptionType: missingField,
                templateTypeId: missingField,
              },
            ],

      payCycles:
        data?.facilityPPPayCycles && data?.facilityPPPayCycles?.length > 0
          ? data?.facilityPPPayCycles?.map(payCycle => {
              return {
                facilityId: payCycle?.facilityId ?? missingField,
                facilityPPId: payCycle?.facilityPPId ?? missingField,
                payCycleId: payCycle?.payCycleId ?? missingField,
                shiftTypeId: payCycle?.shiftTypeId ?? missingField,
                payCycleTypeId: payCycle?.payCycleTypeId ?? missingField,
                startDay: payCycle?.startDay ? formatTime(payCycle?.startDay) : missingField,
                endDay: payCycle?.endDay ?? missingField,
                startTime: payCycle?.startTime ?? missingField,
                endTime: payCycle?.endTime ?? missingField,
                descShiftType: payCycle?.descShiftType ?? missingField,
                descPayCycleType: payCycle?.descPayCycleType ?? missingField,
                descStartDay: payCycle?.descStartDay ?? missingField,
                descEndDay: payCycle?.descEndDay ?? missingField,
                start:
                  (payCycle?.descStartDay ?? missingField) +
                  ' ' +
                  (payCycle?.startTime ? formatTime(payCycle?.startTime) : missingField),
                end:
                  (payCycle?.descEndDay ?? missingField) +
                  ' ' +
                  (payCycle?.endTime ? formatTime(payCycle?.endTime) : missingField),
              };
            })
          : [
              {
                facilityId: missingField,
                facilityPPId: missingField,
                payCycleId: missingField,
                shiftTypeId: missingField,
                payCycleTypeId: missingField,
                startDay: missingField,
                endDay: missingField,
                startTime: missingField,
                endTime: missingField,
                descShiftType: missingField,
                descPayCycleType: missingField,
                descStartDay: missingField,
                descEndDay: missingField,
              },
            ],
      timecardType: data?.bookingDetails?.descTimecardType ?? missingField,
      carRental: data?.bookingDetails?.carRental ?? missingField,
      notes: data?.bookingDetails?.notes ?? missingField,
    },
    mealsAndIncidentalsSection:
      data?.bookingDetails?.mealsAndIncidentals && data?.bookingDetails?.mealsAndIncidentalsFrequency
        ? formatAmount(data?.bookingDetails?.mealsAndIncidentals) +
          '  ' +
          data?.bookingDetails?.mealsAndIncidentalsFrequency
        : missingField,
    housingSection: {
      housingType: data?.bookingDetails?.housingType ?? missingField,
      housingDescription: data?.bookingDetails?.housingDescription ?? missingField,
      limitation: data?.bookingDetails?.limitation ?? missingField,
      housingDetails: data?.housingDetails
        ? data?.housingDetails?.map(housing => {
            return {
              housingDescriptionId: housing?.housingDescriptionId ?? missingField,
              amount: housing?.amount ? formatAmount(housing?.amount) : missingField,
              descHousing: housing?.descHousing ?? missingField,
              housingProviderId: housing?.housingProviderId ?? missingField,
              descHousingProvider: housing?.descHousingProvider ?? missingField,
              utilityCharge: housing?.utilityCharge ? formatAmount(housing?.utilityCharge) : missingField,
            };
          })
        : [
            {
              housingDescriptionId: missingField,
              amount: missingField,
              descHousing: missingField,
              housingProviderId: missingField,
              descHousingProvider: missingField,
              utilityCharge: missingField,
            },
          ],
    },
    travelSection:
      data?.travelAllowances && data?.travelAllowances?.length > 0
        ? data?.travelAllowances?.map(travelAllowance => {
            return {
              facilityId: travelAllowance?.facilityId ?? missingField,
              facilityPPId: travelAllowance?.facilityPPId ?? missingField,
              travelAllowanceId: travelAllowance?.travelAllowanceId ?? missingField,
              allowanceTypeId: travelAllowance?.allowanceTypeId ?? missingField,
              amountPerMile: travelAllowance?.amountPerMile
                ? formatAmount(travelAllowance?.amountPerMile)
                : missingField,
              allowanceCap: travelAllowance?.allowanceCap ? formatAmount(travelAllowance?.allowanceCap) : missingField,
              payerId: travelAllowance?.payerId ?? missingField,
              timestamp: travelAllowance?.timestamp ?? missingField,
              descAllowance: travelAllowance?.descAllowance ?? missingField,
              descPayer: travelAllowance?.descPayer ?? missingField,
            };
          })
        : [
            {
              facilityId: missingField,
              facilityPPId: missingField,
              travelAllowanceId: missingField,
              allowanceTypeId: missingField,
              amountPerMile: missingField,
              allowanceCap: missingField,
              payerId: missingField,
              timestamp: missingField,
              descAllowance: missingField,
              descPayer: missingField,
            },
          ],
    overTimeSection:
      data?.facilityPPOverTimes && data?.facilityPPOverTimes?.length > 0
        ? data?.facilityPPOverTimes?.map(facilityPPOverTime => {
            return {
              facilityId: facilityPPOverTime?.facilityId ?? missingField,
              facilityPPId: facilityPPOverTime?.facilityPPId ?? missingField,
              overtimeType: facilityPPOverTime?.overtimeType ?? missingField,
              shift: facilityPPOverTime?.shift ?? missingField,
              period: facilityPPOverTime?.period ?? missingField,
              hoursWorked: facilityPPOverTime?.hoursWorked ?? missingField,
              notes: facilityPPOverTime?.notes ?? missingField,
            };
          })
        : [
            {
              facilityId: missingField,
              facilityPPId: missingField,
              overtimeType: missingField,
              shift: missingField,
              period: missingField,
              hoursWorked: missingField,
              notes: missingField,
            },
          ],
    holidaySection:
      data?.facilityPPHolidays && data?.facilityPPHolidays?.length > 0
        ? data?.facilityPPHolidays?.map(facilityPPHoliday => {
            return {
              facilityId: facilityPPHoliday?.facilityId ?? missingField,
              facilityPPId: facilityPPHoliday?.facilityPPId ?? missingField,
              holiday: facilityPPHoliday?.holiday ?? missingField,
              holidayDate: facilityPPHoliday?.holidayDate ? formatDate(facilityPPHoliday?.holidayDate) : missingField,
              startTime: facilityPPHoliday?.startTime ? formatTime(facilityPPHoliday?.startTime) : missingField,
              endTime: facilityPPHoliday?.endTime ? formatTime(facilityPPHoliday?.endTime) : missingField,
              useMajorityRule:
                facilityPPHoliday?.useMajorityRule && facilityPPHoliday?.useMajorityRule === 'N'
                  ? 'Hours Worked'
                  : facilityPPHoliday?.useMajorityRule === 'S'
                  ? 'Shift Start Time'
                  : 'Use Majority Rule' ?? missingField,
              startRange: facilityPPHoliday?.startRange ?? missingField,
              endRange: facilityPPHoliday?.endRange ?? missingField,
            };
          })
        : [
            {
              facilityId: missingField,
              facilityPPId: missingField,
              holiday: missingField,
              holidayDate: missingField,
              startTime: missingField,
              endTime: missingField,
              useMajorityRule: missingField,
              startRange: missingField,
              endRange: missingField,
            },
          ],
    qmRequirementSection: {
      stateName: data?.bookingDetails?.state ?? missingField,
      stateLicenseBoards:
        data?.stateLicenseBoards && data?.stateLicenseBoards?.length > 0
          ? data?.stateLicenseBoards?.map(stateLicenseBoard => {
              return {
                disc: stateLicenseBoard?.disc ?? missingField,
                permLicense: stateLicenseBoard?.permLicense ?? missingField,
                walkThrough: stateLicenseBoard?.walkThrough ?? missingField,
                compactState: stateLicenseBoard?.compactState ?? missingField,
                tempLicense: stateLicenseBoard?.tempLicense ?? missingField,
              };
            })
          : [
              {
                disc: missingField,
                permLicense: missingField,
                walkThrough: missingField,
                compactState: missingField,
                tempLicense: missingField,
              },
            ],
      backgroundCheck: [
        {
          backgroundCheckType: data?.bookingDetails?.backgroundCheck ?? missingField,
          processTime: '5 - 10 days',
          years: data?.bookingDetails?.yearsSearched ?? missingField,
          frequency: data?.bookingDetails?.bkFrequency ?? missingField,
        },
        {
          backgroundCheckType: data?.bookingDetails?.stBackgroundCheck ?? missingField,
          processTime: data?.bookingDetails?.stFingerprintsRequiredId === 1 ? 'Fingerprints Required' : '',
          years: data?.bookingDetails?.stYearsSearched ?? missingField,
          frequency: data?.bookingDetails?.stBkFrequency ?? missingField,
        },
      ],
      drugScreen: [
        {
          drugScreenType: data?.bookingDetails?.type ?? missingField,
          frequency: data?.bookingDetails?.frequency ?? missingField,
          panelType: data?.bookingDetails?.panelType ?? missingField,
          drugProcessTime: data?.bookingDetails?.drugProcessTime ?? missingField,
        },
      ],
      qbRequirement: data?.bookingDetails?.qbRequirement
        ? data?.bookingDetails?.qbRequirement.split(/[,\n\r]\s*/).map(x => ({ qbRequirement: x }))
        : [{ qbRequirement: missingField }],
    },

    orientationSection: {
      frequency: data?.bookingDetails?.orientationFrequency ?? missingField,
      day: data?.bookingDetails?.orientationDay ?? missingField,
      notes: data?.bookingDetails?.orientationNotes ?? missingField,
    },
    earlyArrivalSection: {
      earlyArrivaltype: data?.bookingDetails?.earlyArrivalType ?? missingField,
      day: data?.bookingDetails?.earlyArrivalDay ?? missingField,
      responsibleForEMIChargeId: data?.bookingDetails?.responsibleForEMIChargeId ?? missingField,
      notes: data?.bookingDetails?.earlyArrivalNotes ?? missingField,
    },
    additionalInformationSection: {
      postponementPenalty: data?.bookingDetails?.postponementPenalty ?? missingField,
      cancellationPenalty: data?.bookingDetails?.cancellationPenalty ?? missingField,
      unEarnedHousingBenefit: data?.bookingDetails?.uhBenefit
        ? formatAmount(data?.bookingDetails?.uhBenefit)
        : missingField,
    },
    prebookingSection: data?.bookingDetails?.firstDayInstructions ?? missingField,
    unitName: data?.bookingDetails?.unitName ?? missingField,
  };
};
